import { render, staticRenderFns } from "./vtn.vue?vue&type=template&id=4eabf8f7&scoped=true"
import script from "./vtn.vue?vue&type=script&lang=js"
export * from "./vtn.vue?vue&type=script&lang=js"
import style0 from "./vtn.vue?vue&type=style&index=0&id=4eabf8f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eabf8f7",
  null
  
)

export default component.exports